// Static content for PopInReviews.ca
// All 5 quotes are real user feedback provided by the client.

export const BRAND = {
    name: "PopInReviews.ca",
    parentName: "PopIn",
    parentUrl: "https://letspopin.com",
    logo: "https://www.letspopin.com/popin-logo.png",
    tagline: "Stop Blind Networking",
    cta: "Connect like this now",
};

// Featured quotes — locked positions
export const FEATURED_QUOTES = {
    anxiety: {
        text: "Awesome! I really love it. you have solved a problem that bothers me every time I go to an event.",
        author: "PopIn user",
        tag: "Anxiety Solver",
        rotation: "-rotate-1",
    },
    efficiency: {
        text: "Its a cool app — i see folks inside the app that I did not end up meeting — so thanks for that.",
        author: "PopIn user",
        tag: "Efficiency",
        rotation: "rotate-1",
    },
};

// Real quotes from users (no fabricated authors)
export const TESTIMONIALS = [
    {
        id: "q1",
        text: "Hey I checked out Letspopin, seems like a really cool platform!",
        author: "PopIn user",
        tape: "yellow",
        rotation: "-rotate-2",
    },
    {
        id: "q2",
        text: "Discovered you through the CIX slack channel and just used Popin! Great idea.",
        author: "CIX community member",
        tape: "blue",
        rotation: "rotate-1",
    },
    {
        id: "q3",
        text: "I think PopIn is a great product. Great for networking.",
        author: "PopIn user",
        tape: "yellow",
        rotation: "-rotate-1",
    },
    {
        id: "q4",
        text: "Awesome! I really love it. You have solved a problem that bothers me every time I go to an event.",
        author: "Anxious networker, no longer anxious",
        tape: "green",
        rotation: "rotate-2",
    },
    {
        id: "q5",
        text: "Its a cool app — i see folks inside the app that I did not end up meeting — so thanks for that.",
        author: "Event-goer",
        tape: "blue",
        rotation: "-rotate-2",
    },
];

export const EVENTS = [
    {
        id: "the-product-folks-buildation-toronto2026",
        name: "The Product Folks · Buildation Toronto 2026",
        shortName: "Buildation Toronto 2026",
        host: "The Product Folks",
        city: "Toronto, ON",
        vibe: "PMs, builders & makers swapping notes on shipping fast.",
        color: "#E05236",
        tape: "yellow",
        rotation: "-rotate-1",
    },
    {
        id: "healthtech-toronto",
        name: "HealthTech Toronto",
        shortName: "HealthTech Toronto",
        host: "HealthTech Toronto",
        city: "Toronto, ON",
        vibe: "Operators, founders & clinicians shaping the future of care.",
        color: "#2B5F7E",
        tape: "blue",
        rotation: "rotate-1",
    },
    {
        id: "community-connections-summit-toronto2026",
        name: "Community Connections Summit · Toronto 2026",
        shortName: "Community Connections Summit",
        host: "Community Connections",
        city: "Toronto, ON",
        vibe: "A room full of builders who actually want to meet each other.",
        color: "#7C9A5E",
        tape: "green",
        rotation: "-rotate-2",
    },
];

export const findEvent = (id) => EVENTS.find((e) => e.id === id);
